module.exports = __webpack_public_path__ + "img/7_66.7517cdcc.png";